/* eslint-disable no-restricted-globals */
import moment from 'moment';
import { getCurrencySymbol, parseTravelPattern } from './ticket';

export const formatDate = dateString => {
    return moment(dateString).format('ddd Do MMM YYYY HH:mm');
};

export const formatTicketType = (
    serviceName,
    ticketType,
    ticketSubType,
    ticketTravelPattern,
    ticketOptionName
) => {
    let ticketName = `${serviceName} ${ticketType
        .charAt(0)
        .toUpperCase()}${ticketType.slice(1)}`;

    ticketName = ticketName.replace('_', ' ');

    if (ticketOptionName) {
        ticketName += ` ${ticketOptionName}`;
    }

    if (ticketSubType && ticketSubType === 'pm_only') {
        ticketName += ' (PM Only)';
    } else if (ticketSubType && ticketSubType === 'am_only') {
        ticketName += ' (AM Only)';
    } else if (ticketSubType === 'custom' && ticketTravelPattern) {
        ticketName += ` (${parseTravelPattern(ticketTravelPattern)} Only)`;
    }

    return ticketName;
};

export const formatPrice = (price, currency) => {
    const formattedPrice = Number(price);

    if (isNaN(formattedPrice)) {
        return '';
    }

    return `${getCurrencySymbol(currency)}${Number(price).toFixed(2)}`;
};
